export default __webpack_public_path__ + "static/media/shutterstock_2000268743.c12bd925.webp";